;(function($){

    function Units() {
    	var _ = this;


        $("#units-form").submit(function(e) {

            e.preventDefault();

            $.ajax({
               type: "GET",
               url: $("#app_url").val() +"/api/unidades",
               data: $("#units-form").serialize(),
               success: function(data)
               {
                    _.setMap(data, true);
               }
            });
        });  

        // $.get($("#app_url").val() + "/api/unidades", function(data) {
        //    _.setMap(data, false);
        // });  

        new google.maps.Map(document.getElementById('units'), {
          center: {lat: -23.6176838, lng: -46.7182118},
          zoom: 11
        });
        
    }

    Units.prototype.setMap = function(data, filter) {

        if(data == "") {
            
            var modal = new tingle.modal({
                footer: true,
                stickyFooter: false,
                closeLabel: "Close",
                cssClass: ['custom-class-1', 'custom-class-2'],
                onClose: function() {
                    modal.setContent('');
                }
            });        

            modal.addFooterBtn('Enviar', 'tingle-btn tingle-btn--pull-right tingle-btn--default btn-send', function() {

                $("#form-indicated").validate({
                    rules: {
                        name: { required: true },
                        phone: { required: true },
                    },
                    messages: {
                        name: { required: "Informe seu nome" },
                        phone: { required: "Informe o nº do seu telefone" },
                    },
                    submitHandler: function( form ) {
                        
                        $.ajax({
                            type: "POST",
                            dataType: "json",
                            url: $("#app_url").val() + "/api/indicacao",
                            data: $( form ).serialize(),
                            success: function(result)
                            {
                               $(document).find('.tingle-btn--default.btn-send').hide();
                               modal.setContent('<p class="text-center">'+ result.message +'</p>');

                            },
                            error: function(response) {
                                var errors = $.parseJSON(response.responseText);
                               
                                $myForm.showErrors(errors);
                            }
                        });
                    }
                });

                $("#form-indicated").submit();
            });

            modal.addFooterBtn('Fechar', 'tingle-btn tingle-btn--pull-right tingle-btn--danger', function() {
                modal.close();
            });

            modal.setContent('<div class="row">'+
                    '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">'+
                        '<h2 class="title-tingle">'+
                           'Não encontramos unidades na região buscada, deseja indicar algum professor ou estabelecimento?' +
                        '</h2>'+
                    '</div>'+
                '</div>'+
                '<form id="form-indicated">'+
                '<div class="row">'+
                    '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">'+
                        '<div class="form-row">'+
                            '<label for="name">Nome do Indicado</label>'+
                            '<input type="text" id="name" name="name">'+
                        '</div>'+
                    '</div>'+
                    '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">'+
                        '<div class="form-row">'+
                            '<label for="phone">Telefone do Indicado</label>'+
                            '<input type="text" id="phone" name="phone">'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</form>');
                                   
            modal.open(); 

            return false;
        }

        var map;
        var bounds = new google.maps.LatLngBounds();
        var mapOptions = {
            mapTypeId: 'roadmap'
        };
                    
        // Display a map on the page
        map = new google.maps.Map(document.getElementById("units"), mapOptions);
               
        // Multiple Markers
        var markers = [];
                            
        // Info Window Content
        var infoWindowContent = [];

        $.each(data, function(index, value) {
            var modalities = [];

            modalities[index] = value.modalities.map(function(modalitie) {
              return " " + modalitie.name;
            });
            
            var marker = [value.title, value.latitude, value.longitude];
            var contentString = ['<div class="info-box" style="min-height: 200px;">'+
                '<h1 class="title-box">'+ value.name +'</h1>'+
                '<div id="bodyContent">'+
                    '<ul>' +
                        '<li>'+
                            '<span class="title">Modalidades: </span> '+ modalities.join() +
                        '</li>' +
                        '<li>' +
                         '<span class="title">Endereço:</span> '+ value.address +', '+ value.neighborhood +', ' + value.postal_code + ', '+ value.countrie.name + ', ' + value.state.name + ', ' + value.citie.name +' '+
                        '</li>' +
                        '<li>' +
                            '<span class="title">Telefone:</span> '+ value.phone +' / '+ value.cellphone +
                        '</li>' +
                    '</ul>' +
                '<div class="text-center"><a href="'+$("#app_url").val()+'/unidade/'+ value.accrediteds_id+'" class="more">Conheça as Turmas</a></div>' +
                '</div>'+
            '</div>'];

            markers.push(marker);
            infoWindowContent.push(contentString);
        });
        
        // Display multiple markers on a map
        var infoWindow = new google.maps.InfoWindow(), marker, i;
    
        // Loop through our array of markers & place each one on the map  
        for( i = 0; i < markers.length; i++ ) {
            var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
            bounds.extend(position);
            marker = new google.maps.Marker({
                position: position,
                map: map,
                title: markers[i][0],
                icon: $("#app_url").val() + "/public/img/icon-units.png",
                animation: google.maps.Animation.DROP
            });
            
            // Allow each marker to have an info window    
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infoWindow.setContent(infoWindowContent[i][0]);
                    infoWindow.open(map, marker);
                }
            })(marker, i));

            google.maps.event.addListener(marker, 'mouseover', (function(marker, i) {
                return function() {
                    infoWindow.setContent(infoWindowContent[i][0]);
                    infoWindow.open(map, marker);
                }
            })(marker, i));            

            // Automatically center the map fitting all markers on the screen
            map.fitBounds(bounds);
        }

        // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
        var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
            this.setZoom((filter == true) ? 11 : 4);
            google.maps.event.removeListener(boundsListener);
        });
    };

   	new Units();

}(jQuery));